import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isNative } from './runtime.ts';

export async function tapImpact(style: 'light' | 'medium' = 'light'): Promise<void> {
  if (!isNative()) return;
  try {
    await Haptics.impact({
      style: style === 'light' ? ImpactStyle.Light : ImpactStyle.Medium,
    });
  } catch {
    // 일부 시뮬레이터/저사양 기기에서 미지원
  }
}

export async function successImpact(): Promise<void> {
  if (!isNative()) return;
  try {
    await Haptics.notification({ type: NotificationType.Success });
  } catch {
    // ignore
  }
}
